import type { ReactNode } from "react";

import { Skeleton } from "../../../shared/ui";
import { ErrorRetry } from "../ErrorRetry";
import { PermissionDenied } from "../PermissionDenied";
import type { LoadState } from "./useAccessLoad";
import { useAccessT } from "./useAccessT";

/** Renders the shared loading, failed, denied and not-found states. */
export function LoadGate<T>({
  state,
  retry,
  children,
}: {
  state: LoadState<T>;
  retry: () => void;
  children: (data: T) => ReactNode;
}) {
  const t = useAccessT();
  switch (state.kind) {
    case "loading":
      return (
        <div aria-busy="true">
          <Skeleton height={56} />
          <span className="sr-only">{t("admin.access.loading")}</span>
        </div>
      );
    case "denied":
      return <PermissionDenied message={t("admin.denied.access")} />;
    case "notFound":
      return (
        <p className="text-body text-fg-muted">{t("admin.access.notFound")}</p>
      );
    case "failed":
      return <ErrorRetry message={t("admin.access.failed")} onRetry={retry} />;
    case "ready":
      return <>{children(state.data)}</>;
  }
}
